import React from 'react';
import { FloatingSearchBar } from '../components/FloatingSearchBar';
import { HeroBanner } from '../components/HeroBanner';
import { QuickEntryPanel } from '../components/QuickEntryPanel';
import { SectionBlock } from '../components/SectionBlock';
import { ActivityCard } from '../components/ActivityCard';
import { FeatureImageCard } from '../components/FeatureImageCard';
import { HeatMiniPanel } from '../components/HeatMiniPanel';
import { ElderFloatingButton } from '../components/ElderFloatingButton';
import { ScrollArea } from '../components/ScrollArea';
import { homeSections, activityList, featureCards } from '../constants/mockData';
import { ASSETS } from '../constants/assets';
import { Home as HomeIcon, Compass, Heart } from 'lucide-react';
export function Home() {
  return <div className="min-h-screen bg-[#EEF8F8] pb-24 relative" data-id="element-255">
      <FloatingSearchBar data-id="element-256" />
      <ElderFloatingButton data-id="element-257" />

      <main data-id="element-258">
        <HeroBanner data-id="element-259" />
        <QuickEntryPanel data-id="element-260" />

        {homeSections.map(section => <SectionBlock key={section.key} title={section.title} categories={section.categories} data-id="element-261">
            {section.type === 'activity' && <div className="px-4 flex flex-col gap-4" data-id="element-262">
                {activityList.map(activity => <div key={activity.id} onClick={() => window.location.href = `/event-detail/${activity.id}`} className="cursor-pointer active:opacity-90" data-id="element-263">
                    <ActivityCard {...activity} data-id="element-264" />
                  </div>)}
              </div>}

            {section.type === 'imageCards' && <div className="flex overflow-x-auto no-scrollbar gap-4 px-4 pb-2" data-id="element-265">
                {featureCards.filter(card => card.section === section.key).map(card => <div key={card.id} onClick={() => window.location.href = `/scenic-detail/${card.id}`} data-id="element-266">
                      <FeatureImageCard {...card} data-id="element-267" />
                    </div>)}
                {/* Fallback if no cards for section in mock */}
                {featureCards.filter(card => card.section === section.key).length === 0 && <div className="w-full py-10 flex flex-col items-center justify-center text-gray-400 gap-2" data-id="element-268">
                    <img src={ASSETS.emptyState} alt="Empty" className="size-24 opacity-50" data-id="element-269" />
                    <span className="text-sm" data-id="element-270">暂无相关资源</span>
                  </div>}
              </div>}

            {section.type === 'heatmap' && <div className="px-4" onClick={() => window.location.href = '/heatmap'} data-id="element-271">
                <HeatMiniPanel data-id="element-272" />
              </div>}

            {section.type === 'sports' && <div className="px-4 flex flex-col gap-4" data-id="element-273">
                <div className="relative h-32 rounded-2xl overflow-hidden shadow-sm" data-id="element-274">
                  <img src={ASSETS.sportsBanner} alt="Sports" className="w-full h-full object-cover" data-id="element-275" />
                  <div className="absolute inset-0 bg-black/20 flex items-center px-6" data-id="element-276">
                    <h3 className="text-white text-xl font-bold" data-id="element-277">
                      跟着赛事游宿州
                    </h3>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-278">
                  <div className="bg-white p-3 rounded-2xl shadow-sm border border-gray-100 flex flex-col gap-2" data-id="element-279">
                    <img src={ASSETS.sportsVenue} alt="Venue" className="h-24 rounded-xl object-cover" data-id="element-280" />
                    <span className="text-sm font-bold text-[#333333]" data-id="element-281">
                      赛事场馆
                    </span>
                  </div>
                  <div className="bg-white p-3 rounded-2xl shadow-sm border border-gray-100 flex flex-col gap-2" data-id="element-282">
                    <img src={ASSETS.sportsRouteHalfday} alt="Route" className="h-24 rounded-xl object-cover" data-id="element-283" />
                    <span className="text-sm font-bold text-[#333333]" data-id="element-284">
                      赛后路线
                    </span>
                  </div>
                </div>
              </div>}
          </SectionBlock>)}
      </main>

      {/* Tab Bar */}
      <nav className="fixed bottom-0 left-0 right-0 h-20 bg-white/95 backdrop-blur-md border-t border-gray-100 flex items-center justify-around px-6 z-50 shadow-[0_-4px_12px_rgba(0,0,0,0.03)]" data-id="element-285">
        <div onClick={() => window.location.href = '/'} className="flex flex-col items-center gap-1 text-[#66CADA] cursor-pointer" data-id="element-286">
          <HomeIcon className="size-6" data-id="element-287" />
          <span className="text-[22rpx] font-bold" data-id="element-288">首页</span>
        </div>
        <div onClick={() => window.location.href = '/explore'} className="flex flex-col items-center gap-1 text-[#999999] cursor-pointer hover:text-[#66CADA] transition-colors" data-id="element-289">
          <Compass className="size-6" data-id="element-290" />
          <span className="text-[22rpx]" data-id="element-291">游宿州</span>
        </div>
        <div onClick={() => window.location.href = '/service'} className="flex flex-col items-center gap-1 text-[#999999] cursor-pointer hover:text-[#66CADA] transition-colors" data-id="element-292">
          <Heart className="size-6" data-id="element-293" />
          <span className="text-[22rpx]" data-id="element-294">享服务</span>
        </div>
      </nav>
    </div>;
}